import type { BlockEditProps } from "@wordpress/blocks";
import type { BlockAttributes } from "./block.json";
import { useEntityProp } from "@wordpress/core-data";

import {
  RichText,
  useBlockProps,
  useInnerBlocksProps,
} from "@wordpress/block-editor";
import PostThumbnailEditor from "../../../source/components/PostThumbnailEditor";

export default function LeitungInfoEditor(
  props: BlockEditProps<BlockAttributes>
): JSX.Element {
  const [meta, updateMeta] = useEntityProp(
    "postType",
    props.context.postType as string,
    "meta",
    props.context.postId as string
  );

  const firstName = meta?.first_name || "";
  const lastName = meta?.last_name || "";
  const position = meta?.position || "";

  const updatePosition = (newPosition: string) => {
    updateMeta({ ...meta, position: newPosition });
  };

  // Function to update full title when either first or last name changes
  const updateTitle = (first: string, last: string) => {
    const fullName = `${first} ${last}`.trim();
    setTitle(fullName);
  };

  // Update first name and title
  const updateFirstName = (value: string) => {
    updateMeta({ ...meta, first_name: value });
    updateTitle(value, lastName);
  };

  // Update last name and title
  const updateLastName = (value: string) => {
    updateMeta({ ...meta, last_name: value });
    updateTitle(firstName, value);
  };

  // Keep the title field for compatibility
  const [title, setTitle] = useEntityProp(
    "postType",
    props.context.postType as string,
    "title",
    props.context.postId as string
  );

  return (
    <div {...useBlockProps({ className: "py-section alignfull" })}>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-4">
            <PostThumbnailEditor
              postType={props.context.postType as string}
              postId={props.context.postId as number}
              className="object-fit-cover"
              wrapClassName="ratio ratio-1x1"
            />
          </div>
          <div className="col-12 col-md-7 offset-md-1">
            <h1 className="h2">
              <RichText
                value={firstName}
                onChange={updateFirstName}
                multiline={false}
                placeholder="Vorname"
              />
            </h1>
            <h1 className="h2 py-2">
              <RichText
                value={lastName}
                onChange={updateLastName}
                multiline={false}
                placeholder="Nachname"
              />
            </h1>
            <div className="mb-4">
              <RichText
                value={position}
                onChange={updatePosition}
                multiline={false}
                className="position-field"
                placeholder="/ Position"
                allowedFormats={[]}
              />
            </div>
            <div {...useInnerBlocksProps({ className: "mt-5" })} />
          </div>
        </div>
      </div>
    </div>
  );
}
